<template>
  <section class="body-sign">
    <div class="center-sign">
      <div class="panel card-sign">
        <div class="card-title-sign mt-3 text-end d-flex justify-content-between">
          <img src="logo_login.png" height="70" alt="Porto Admin">
          <h2 class="title text-uppercase font-weight-bold m-0"><i class="bx bx-user-circle me-1 text-6 position-relative top-5"></i> Prijava</h2>
        </div>
        <div class="card-body">
          <form @submit.prevent="submitForm">
            <div class="form-group mb-3">
              <label>Korisničko ime</label>
              <div class="input-group">
                <input name="username" ref="usernameInput" v-model="username" type="text" autocomplete="username" class="form-control form-control-lg">
                <span class="input-group-text">
                  <i class="bx bx-user text-4"></i>
                </span>
              </div>
            </div>

            <div class="form-group mb-3">
              <div class="clearfix">
                <label class="float-left">Lozinka</label>
                <router-link class="float-end" exact :to="{ name: 'ForgotPassword' }">
                  Zaboravljena lozinka?
                </router-link>
              </div>
              <div class="input-group">
                <div class="password-wrapper d-flex">
                  <input name="pwd"
                    ref="passwordInput"
                    :type="showPassword ? 'text' : 'password'"
                    v-model="password"
                    autocomplete="current-password"
                    class="form-control form-control-lg"
                  >
                  <div class="password-icon-wrapper">
                    <i
                      :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
                      @click="togglePassword"
                    />
                  </div>
                </div>
                <span class="input-group-text">
                  <i class="bx bx-lock text-4"></i>
                </span>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div class="col-sm-8">
                <!-- <div class="checkbox-custom checkbox-default">
                  <input id="RememberMe" name="rememberme" type="checkbox">
                  <label for="RememberMe">Remember Me</label>
                </div> -->
                <div class="col-sm-10">
                  <vue-recaptcha
                    v-if="captchaProvider === 'recaptcha'"
                    ref="recaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                    :sitekey="siteKey"
                  ></vue-recaptcha>
                  <div v-else ref="turnstile"></div>
              </div>

              </div>
              <div class="col-sm-4 text-end">
                <button type="submit" class="btn btn-primary mt-2">Prijavi se</button>
              </div>
            </div>
            <!-- <span class="mt-3 mb-3 line-thru text-center text-uppercase">
                <span>or</span>
            </span>
            <p class="text-center">Don't have an account yet? 
              <router-link exact :to="{ name: 'Register' }">
                Sign Up
              </router-link>
            </p> -->

          </form>
        </div>
      </div>

      <p class="text-center text-muted mt-3 mb-3">© Copyright 2023. Sva prava zadržana.</p>
    </div>
  </section>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
import api from '@/services/api';
import config from '@/config';

export default {
  name: 'Login',
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      username: '',
      password: '',
      successCaptcha: false,
      showPassword: false,
      turnstileWidgetId: null,
    };
  },
  computed: {
    captchaProvider() {
      return config.captcha.provider;
    },
    siteKey() {
      return this.captchaProvider === 'recaptcha'
        ? config.captcha.reCaptchaSiteKey
        : config.captcha.turnstileSiteKey;
    },
  },
  mounted() {
    const token = localStorage.getItem('token');
    const { query } = this.$route;

    const { redirectTo } = query;

    if (token && !redirectTo) {
      this.$router.push({ name: 'Dashboard' });
      return;
    }

    if (token && redirectTo) {
      window.location.replace(redirectTo);
      return;
    }

    if (this.captchaProvider !== 'recaptcha') {
      this.renderTurnstile();
    }
  },
  beforeDestroy() {
    if (window.turnstile && this.turnstileWidgetId !== null) {
      window.turnstile.remove(this.turnstileWidgetId);
    }
  },
  methods: {
    renderTurnstile() {
      if (!window.turnstile) {
        setTimeout(this.renderTurnstile, 300);
        return;
      }

      this.turnstileWidgetId = window.turnstile.render(this.$refs.turnstile, {
        sitekey: this.siteKey,
        callback: () => {
          this.successCaptcha = true;
        },
        'expired-callback': () => {
          this.successCaptcha = false;
        },
        'error-callback': () => {
          this.successCaptcha = false;
        },
      });
    },
    resetCaptcha() {
      this.successCaptcha = false;
      if (this.captchaProvider === 'recaptcha') {
        if (this.$refs.recaptcha) this.$refs.recaptcha.reset();
      } else if (window.turnstile && this.turnstileWidgetId !== null) {
        window.turnstile.reset(this.turnstileWidgetId);
      }
    },
    submitForm() {
      if (this.successCaptcha) {
        const username = this.$refs.usernameInput.value;
        const password = this.$refs.passwordInput.value;
        this.username = username;
        this.password = password;
        api.login({ username, password }).then((response) => {
          const { query } = this.$route;
          const { redirectTo } = query;

          localStorage.setItem('token', response.data.token);
          this.$store.dispatch('storeProfileData', response.data);

          if (!redirectTo) {
            this.$router.push({ name: 'Dashboard' });
          } else {
            window.location.replace(redirectTo);
          }

        }).catch(err => {
          this.$toast.error(err.response.data.info);
          this.resetCaptcha();
        });
      } else {
        this.$toast.error('Molimo označite reCAPTCHA/Turnstile provjeru');
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    onVerify(data) {
      if (data) this.successCaptcha = true;
    },
    onExpired() {
      this.successCaptcha = false;
    },
  },
}
</script>
<style>
.password-wrapper {
  position: relative;
  width: 89%;
  max-width: 480px;
  display: flex;
  justify-content: space-between;
}

.password-icon-wrapper {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  width: 20px;
  top: 17px;
  right: 15px;
}
</style>
